import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error File is untyped
import imageUrl from 'bender-url!documents-ui/images/no-results.svg';
import { Text } from 'foundations-components/components/Text';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Image } from 'foundations-components/transitional/components/Image';
import SummaryEmptyTable from './SummaryEmptyTable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function SummaryNoSearchResults() {
  return /*#__PURE__*/_jsxs(SummaryEmptyTable, {
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "SUMMARY_LOAD"
    }), /*#__PURE__*/_jsxs(TFlex, {
      align: "center",
      direction: "column",
      padding: "1000",
      children: [/*#__PURE__*/_jsx(Image, {
        width: 100,
        src: imageUrl,
        responsive: false,
        marginBlock: "1000"
      }), /*#__PURE__*/_jsx(Text, {
        as: "h4",
        marginBlockEnd: "300",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "summary.emptySearch.nothingMatchesSearch"
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "summary.emptySearch.checkSpelling"
        })
      })]
    })]
  });
}